export interface FilterFormRow {
  filter: { code?: string; [key: string]: any };
  loading: boolean;
  search: string;
  dimensionValues: any[];
}

export function makeFilterForm(filter: any): FilterFormRow {
  return { filter, loading: false, search: '', dimensionValues: [] };
}

/**
 * Append `newFilter` to the filter rows, consuming the trailing blank row (a
 * row the user opened with "Add Filter" but never picked a column for) when
 * there is one. Mutates `forms` in place so Vue keeps tracking the same array.
 *
 * splice() returns the items it removed, so assigning its result back over
 * `forms` used to drop every existing filter and leave only `newFilter`.
 */
export function appendFilterForm(forms: FilterFormRow[], newFilter: any): FilterFormRow[] {
  const count = forms.length;
  if (count > 0 && !forms[count - 1].filter.code) {
    forms.splice(count - 1, 1);
  }
  forms.push(makeFilterForm(newFilter));
  return forms;
}
